import { render, staticRenderFns } from "./MultimediaModal.vue?vue&type=template&id=624ce460&scoped=true&"
import script from "./MultimediaModal.vue?vue&type=script&lang=js&"
export * from "./MultimediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624ce460",
  null
  
)

export default component.exports